require('./ctxNumberDisplay.style.scss');

class NumberDisplayController {
    constructor($scope, $element) {
        this.$element = $element;
        this.$scope = $scope;
    }
}

const numberDisplayComponent = {
    controller: NumberDisplayController,
    scope: {},
    template: require('./ctxNumberDisplay.template.html'),
    bindings: {
        value: '<',
        label: '@'
    }
};

NumberDisplayController.$inject = ['$scope', '$element', 'styleService'];

module.exports = numberDisplayComponent;




// WEBPACK FOOTER //
// ./src/shared/ctxNumberDisplay/ctxNumberDisplay.component.js